import { gql } from "@apollo/client";

export const organizationPermissionsFragment = gql`
    fragment OrganizationPermissions on CameraKitOrganization {
        permissions {
            readGroups
            updateGroups
            readLenses
            updateLenses
            scheduleLenses
            readLensSources
            updateLensSources
            readLensAnalytics
        }
    }
`;
